import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { CurrencyIcon } from '@root/entities/currency/ui'
import { PremiumText } from '@root/entities/premium/ui'
import { PremiumGradientIcon } from '@root/shared/ui-kit'

import { PremiumPurchaseBoostersBadge } from './common/purchase-boosters-badge'
import { PairActivitySnackbarBase } from './pair-activity-snackbar-base'

import type { PairActivity } from '../model'

type Props = {
  activity: PairActivity.PremiumPurchased
  onClose?: () => void
}

export const PairActivitySnackbarPremium = ({ activity, onClose }: Props) => {
  const { currency } = activity
  const { t } = useTranslation()

  return (
    <PairActivitySnackbarBase onClose={onClose} activity={activity}>
      <Root>
        <CurrencyDetails>
          <CurrencyIcon currency={currency} size={24} withNetwork />
          <Ticker>
            <PremiumText>{currency.ticker}</PremiumText>
          </Ticker>
        </CurrencyDetails>
        <Separator />
        <Message>
          <PremiumIcon size={13} />
          <PremiumTextStyled>{t('common.d-premium')}</PremiumTextStyled>
          <PremiumPurchaseBoostersBadge boosters={activity.boostersAmount} />
          {t('pair-activity.premium-purchased')}
        </Message>
      </Root>
    </PairActivitySnackbarBase>
  )
}

const Root = styled.div`
  display: grid;
  align-items: center;
  grid-auto-flow: column;
  gap: 8px;
`

const CurrencyDetails = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 8px;
  justify-items: start;
  justify-content: start;
`

const Ticker = styled.span`
  color: var(--text-12);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
`

const Message = styled.span`
  color: var(--up-9);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;

  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 2px;
`

const PremiumTextStyled = styled(PremiumText)`
  font-weight: 600;
`

const Separator = styled.div`
  background: var(--backgroundA-4);
  width: 1px;
  height: 13px;
`

const PremiumIcon = styled(PremiumGradientIcon)`
  margin-right: 2px;
  margin-top: -2px;
`
